__turbopack_context__.v({
  "actions": "Callout-module___zN47W__actions",
  "body": "Callout-module___zN47W__body",
  "callout": "Callout-module___zN47W__callout",
  "error": "Callout-module___zN47W__error",
  "marker": "Callout-module___zN47W__marker",
  "note": "Callout-module___zN47W__note",
  "title": "Callout-module___zN47W__title",
  "warning": "Callout-module___zN47W__warning",
});
